import type { RadioConfig } from '#types/config/components/vf/radio'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      variant: {
        base: {
          selected: 'ring-grey-40 c-brand-1'
        }
      }
    },
    label: {
      shared: 'subtitle-5'
    }
  }
} satisfies RecursivePartial<RadioConfig>
